module.exports = __webpack_public_path__ + "img/logo.749b0e59.jpg";